module.exports = __webpack_public_path__ + "img/welding-4.608c3f5a.jpg";